<!-- 推荐使用grid-table-th替代 -->
<template>
  <li class="mTable-cell mTable-cell-medium">
    <div class="mTable-cell-wrap">
      <span class="mTable-txt"><slot></slot></span>
    </div>
  </li>
</template>
<script>
  export default {
    name: 'grid-table-col'
  }
</script>



// WEBPACK FOOTER //
// src/components/grid-menu/grid-table-col.vue